import { render } from "./VoiceDock.vue?vue&type=template&id=2e041e2e&scoped=true"
import script from "./VoiceDock.vue?vue&type=script&lang=js"
export * from "./VoiceDock.vue?vue&type=script&lang=js"

import "./VoiceDock.vue?vue&type=style&index=0&id=2e041e2e&scoped=true&lang=css"
import "./VoiceDock.vue?vue&type=style&index=1&id=2e041e2e&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e041e2e"]])

export default __exports__